import * as Yup from "yup";

// Shared password-complexity rules. Applied ONLY to:
//   - the account password on registration (AccountInfo step)
//   - the new password on the password-reset page
//
// Explicitly NOT applied to admin PIN, user PIN, forgot-PIN, or any 4-digit
// field - those have their own (numeric, fixed-length) validation.
//
// Requirements:
//   - at least 8 characters
//   - at least 1 number
//   - at least 1 uppercase letter
//   - no character repeated 3+ times in a row (e.g. "aaa", "111")

export const passwordRules = [
  {
    id: "min8",
    label: "At least 8 characters",
    test: (value) => String(value ?? "").length >= 8,
  },
  {
    id: "number",
    label: "At least 1 number",
    test: (value) => /[0-9]/.test(String(value ?? "")),
  },
  {
    id: "uppercase",
    label: "At least 1 uppercase letter",
    test: (value) => /[A-Z]/.test(String(value ?? "")),
  },
  {
    id: "noTripleRepeat",
    label: "No character repeated 3+ times in a row",
    test: (value) => !/(.)\1\1/.test(String(value ?? "")),
  },
];

// Per-rule pass/fail map for a live requirements checklist UI.
export const checkPasswordRules = (value) =>
  passwordRules.reduce((acc, rule) => {
    acc[rule.id] = rule.test(value);
    return acc;
  }, {});

export const passwordSchema = passwordRules
  .reduce(
    (schema, rule) => schema.test(rule.id, rule.label, (value) => rule.test(value)),
    Yup.string().required("Password is required")
  );
